import React, { useEffect, useMemo, useRef, useState } from 'react'
import GlobalStyles from 'components/GlobalStyles'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import { ThemeProvider } from 'emotion-theming'
import Store from 'flow/store'

// common
import ConnectedIntlProvider from 'common/wording/intl'
import Loader from 'components/Loader'
import Loader1 from 'components/Loader1'
import theme from 'common/styles/theme'

// pages
import Main from 'views/Main'

function App () {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (loading ? <Loader1 /> :
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Store>
        <Router>
          <ConnectedIntlProvider>
            <Switch>
              <Route path='/:nodeId?'>
                <Main />
              </Route>
            </Switch>
          </ConnectedIntlProvider>
        </Router>
      </Store>
    </ThemeProvider>
  )
}

export default App
